module.exports = __webpack_public_path__ + "5e1b4edd402957ef4bd3c6c6c01e2381.png";